import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

const giteaAuthApiRef = createApiRef<any>().with({
  id: 'internal.auth.gitea',
  pluginId: 'app',
});

const giteaAuthApi = ApiBlueprint.make({
  name: 'gitea-auth-api',
  params: define =>
    define({
      api: giteaAuthApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'gitea',
            title: 'Gitea',
            icon: AccountTreeIcon,
          },
          defaultScopes: ['openid', 'profile', 'email'],
          environment: configApi.getOptionalString('auth.environment'),
        }),
    }),
});

const giteaSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          providers={[
            {
              id: 'gitea',
              title: 'Gitea',
              message: 'Sign in with Gitea',
              apiRef: giteaAuthApiRef,
            },
          ]}
        />
      ),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [giteaAuthApi, giteaSignInPage],
});
